//Docs: http://jqueryvalidation.org/documentation/

(function ($) {

    var LOWER = /[a-z]/,
        UPPER = /[A-Z]/,
        DIGIT = /[0-9]/,
        DIGITS = /[0-9].*[0-9]/,
        SPECIAL = /[^a-zA-Z0-9]/,
        SAME = /^(.)\1+$/;


    $.validator.addMethod("passwordComplexity", function (value, element) {
        var password = element.value;

        //if (!password || password.length < 8)
        //    return false;

        //if (SAME.test(password))
        //    return false;

        var score = (UPPER.test(password) ? 1 : 0)
                  + (LOWER.test(password) ? 1 : 0);

        if (score >= 2) {
            return true;
        } else {
            return false;
        }

    }, "Your password needs to have at least one lower case and one upper case letter");

    $.validator.addMethod("passwordNotLikeUsername", function (value, element, usernameField) {
        var password = element.value;
        var usernameEl = $(typeof usernameField != "boolean" ? usernameField : []);
        var username = usernameEl.val();

        if (!password)
            return false;

        if (username && password.toLowerCase().match(username.toLowerCase()))
            return false;

        return true;
    
    }, "Your password is too similar to your username"); 
    

    $.validator.addMethod("mustMatch", function (value, element, otherPwdField) {
        var password = element.value;
        var otherPwd = $(otherPwdField).val();
         
        return password === otherPwd;

    }, "This doesn't match your new password.");

    // manually add class rule, to make username param optional
    //$.validator.classRuleSettings.password = { password: true };

})(jQuery);